angular
    .module('app')
    .controller('EditMembersControllerEx', function ($window, $uibModalInstance, 
// parameters that are passed into the modal
supportUser, team) {
    let vm = this;
    vm.state = {};
    vm.data = {
        members: [],
        testers: []
    };
    vm.close = close;
    function close() {
        $uibModalInstance.close();
    }
    function init() {
        let teamId = team.Id;
        vm.state.selectedTeam = team;
        return;
    }
    init();
});
